

import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  MenuItem,
  Card,
  Select,
  InputAdornment,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import emailjs from "emailjs-com";
import Contactimgtop from "../component/Contactimgtop";
import ContactimageBottom from "../component/ContactimageBottom";
import useTracking from "../hooks/useTracking";

export default function ContactPage() {

   const { ref, handleClick } = useTracking("ContactPage");


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    requirement: "",
    message: "",
    countryCode: "+971"
  });




  // Handle country code change
  const handleCountryCodeChange = (e) => {
    setFormData({
      ...formData,
      countryCode: e.target.value
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, mobile: value }));
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form data
    if (!formData.firstName || !formData.email || !formData.message) {
      alert("Please fill in all required fields.");
      return;
    }

    if (formData.mobile.length < 5) {
      alert("Please enter  phone number.");
      return;
    }

    // Send email via EmailJS
    emailjs
      .send(
        "service_6rfhrvk", // Your Service ID
        "template_99vzkzg", // Correct Template ID from the EmailJS dashboard
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          mobile: formData.mobile,
          requirement: formData.requirement,
          message: formData.message,
        },
        "Ul9odn6d0Od9P-0r6" // Your Public Key
      )
      .then(
        (response) => {
          console.log(
            "Email sent successfully!",
            response.status,
            response.text
          );
          alert("Message sent successfully!");

          // Reset form data
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            requirement: "",
            message: "",
          });
        },
        (error) => {
          console.error("Error sending email:", error);
          alert("Failed to send the message. Please try again.");
        }
      )
      .catch((error) => {
        console.error("Network or email service error:", error);
        alert("Failed to send the message. Please try again.");
      });
  };

  return (

    <>

      <Contactimgtop />

      <Box ref={ref} sx={{ p: { xs: 2, md: "20px" } }}>

        <Grid container spacing={3} alignItems="stretch">

          {/* Left: Contact Form */}
          <Grid item xs={12} sm={12} md={6}>
            <Box>
              <Typography
                variant="h3"
                sx={{ fontWeight: 900, color: "#374D91", mb: 3, textAlign: "left", fontFamily: 'Poppins', }}
              >
                Get In <br /> Touch With Us
              </Typography>

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>

                    <Typography sx={{ mb: 0.8, fontWeight: 500, color: "#414651", textAlign: "left", fontSize: "14px", fontFamily: "poppins" }}>
                      First Name
                    </Typography>
                    <TextField
                      placeholder="Enter First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      fullWidth
                      variant="outlined"
                      InputProps={{
                        sx: {
                          borderRadius: "8px",     // rounded corners
                          "& fieldset": {
                            borderColor: "#ccc",   // default border
                          },
                          "&:hover fieldset": {
                            borderColor: "#999",   // hover border
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91",
                            borderWidth: "1.5px",
                          },

                           "& input::placeholder": {
                            color: "#717680",
                            opacity: 1,
                          },},}}
                      />
                  </Grid>
                  <Grid item xs={12} sm={6}>


                    <Typography sx={{ mb: 0.8, fontWeight: 500, color: "#414651", textAlign: "left", fontSize: "14px", fontFamily: "poppins" }}>
                      Last Name
                    </Typography>
                    <TextField
                      placeholder="Enter Last Name"
                      name="lastName"
                      fullWidth
                      value={formData.lastName}
                      onChange={handleChange}

                      variant="outlined"

                      InputProps={{
                        sx: {
                          borderRadius: "8px",     // rounded corners
                          "& fieldset": {
                            borderColor: "#ccc",   // default border
                          },
                          "&:hover fieldset": {
                            borderColor: "#999",   // hover border
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91", // focus border (blue like screenshot)
                            borderWidth: "1.5px",
                          },
                           "& input::placeholder": {
                            color: "#717680",
                            opacity: 1,
                          },
                        },
                      }}
                      
                    />


                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={{ mb: 0.8, fontWeight: 500, color: "#414651", textAlign: "left", fontSize: "14px", fontFamily: "poppins" }}>
                      Email
                    </Typography>
                    <TextField
                      placeholder="Enter Email"
                      name="email"
                      type="email"
                      fullWidth
                      value={formData.email}
                      onChange={handleChange}
                      required
                      InputProps={{
                        sx: {
                          borderRadius: "8px",     // rounded corners
                          "& fieldset": {
                            borderColor: "#ccc",   // default border
                          },
                          "&:hover fieldset": {
                            borderColor: "#999",   // hover border
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91", // focus border (blue like screenshot)
                            borderWidth: "1.5px",
                          },

                          "& input::placeholder": {
                            color: "#717680",
                            opacity: 1,
                          },
                        },
                      }}
                   
                    />
                  </Grid>



                  <Grid item xs={12} sm={6}>
                    <Typography sx={{
                      mb: 0.8,
                      fontWeight: 500,
                      color: "#414651",
                      textAlign: "left",
                      fontSize: "14px",
                      fontFamily: "poppins"
                    }}>
                      Phone Number
                    </Typography>

                    <TextField
                      fullWidth
                      required
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="Enter Phone Number"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Select
                              value={formData.countryCode || "+971"}
                              onChange={handleCountryCodeChange}
                              sx={{
                                border: "none",
                                "& fieldset": { border: "none" },
                                "& .MuiSelect-select": {
                                  padding: "8px 1px",
                                  display: "flex",
                                  alignItems: "center",
                                  minWidth: "30px"
                                }
                              }}
                            >
                              <MenuItem value="+971">+971</MenuItem>
                              <MenuItem value="+961">+961</MenuItem>
                            </Select>
                          </InputAdornment>
                        ),
                        sx: {
                          borderRadius: "8px",
                          height: "56px",
                          "& fieldset": {
                            borderColor: "#ccc"
                          },
                          "&:hover fieldset": {
                            borderColor: "#999"
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91",
                            borderWidth: "1.5px",
                          },
                          "& input::placeholder": {
                            color: "#717680",
                            opacity: 1,
                          },
                        },
                      }}
                      inputProps={{
                        style: {
                          padding: "14px",
                          fontSize: "16px",
                          paddingLeft: "0px"
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        mb: 0.8,
                        fontWeight: 500,
                        color: "#414651",
                        textAlign: "left",
                        fontSize: "14px",
                        fontFamily: "poppins"
                      }}
                    >
                      Requirement
                    </Typography>
                    <TextField
                      select
                      name="requirement"
                      value={formData.requirement}
                      onChange={handleChange}
                      fullWidth
                      required
                      displayEmpty
                      InputProps={{
                        sx: {
                          borderRadius: "8px",
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#999" },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91",
                            borderWidth: "1.5px",
                          },
                          // Yeh bhi try kar sakte hain
                          "& .MuiSelect-select": {
                            textAlign: "left",
                          }
                        },
                      }}
                      inputProps={{ style: { padding: "14px", fontSize: "16px" } }}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (selected === "") {
                            return <span style={{ color: '#717680' }}>Select Requirement</span>;
                          }
                          return selected;
                        }
                      }}
                      sx={{
                        "& .MuiSelect-select": {
                          textAlign: "left !important",
                        }
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Requirement
                      </MenuItem>

                      <MenuItem value="General Inquiry">General Inquiry</MenuItem>
                      <MenuItem value="Logistics Support">Logistics Support</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </TextField>
                  </Grid>


                  <Grid item xs={12}>

                    <Typography sx={{ mb: 0.8, fontWeight: 500, color: "#414651", textAlign: "left", fontSize: "14px", fontFamily: "poppins" }}>
                      Message
                    </Typography>
                    <TextField
                      placeholder="Enter a Message..."
                      name="message"
                      fullWidth
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      // required

                      InputProps={{
                        sx: {
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#374D91",
                            borderWidth: "1.5px",
                          },

                        },
                      }}
                      inputProps={{
                        style: {
                          padding: "2px",
                          fontSize: "16px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      sx={{
                        fontSize: "14px",
                        backgroundColor: "#374D91",
                        color: "#f7ef6d",
                        borderRadius: "25px",
                        py: 1.5,
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        "&:hover": { backgroundColor: "#2c3b75" },
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>

          {/* Right: Image */}
          <Grid item xs={12} sm={12} md={6}>
            <Box
              component="img"
              // src="/right1.png"
              src="/right11.png"
              alt="Contact Us"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: 2,
                // objectFit: "cover",
              }}
            />
          </Grid>

        </Grid>

      </Box>


      <Box sx={{
        // mx: { xs: 1, sm: 2 },
        px: { xs: 2, sm: 2, md: 2 },
        mb: { xs: 4, sm: 4, md: 4 },

      }}>

        <ContactimageBottom />
      </Box>

    </>
  );
}